module.exports = __webpack_public_path__ + "static/media/Moj-1.81b9d0da.PNG";